import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

import CarouselWrapper from "./CarouselWrapper";
import ActiveSelections from "./ActiveSelections";

function MoodBoard(props){
  const selections = props.store.persistStore.moodBoardSelections;
  const activeSelections = props.store.persistStore.activeSelections;
  const [slideIndex, setSlideIndex] = useState(0);

  const onActiveSelectionClick = () => {
      if (!selections[slideIndex].active) selections[slideIndex].toggleActive();
  };

  return (
      <div className="MoodBoard">
         <CarouselWrapper
           slideIndex={slideIndex}
           setSlideIndex={setSlideIndex}
           selections={selections} />

         <div className="activeSelection">
             <ActiveSelections
               onActiveSelectionClick={onActiveSelectionClick}
               activeSelections={activeSelections} />
         </div>
      </div>
  );
}

export default observer(MoodBoard);
